import api from './api';

const changeHistoryService = {
    async getHistory(params = {}) {
        const response = await api.get('/change-history', { params });
        return response.data;
    },

    async getHistoryById(id) {
        const response = await api.get(`/change-history/${id}`);
        return response.data;
    }
};

export default changeHistoryService;
